import { NAWSurvey } from '../../../../../types/NAW/Survey'
import { Update } from '../../../../hooks/NAW/useNAWSurveyAnswer/useNAWSurveyAnswer'
import { FullHeightContentWrapper } from '../PageList'
import Config from './Config'
import DeskSharingAndSummary from './DeskSharingAndSummary'
import Result from './Result'
import GoBack from '../GoBack/GoBack'

type Props = {
  survey: NAWSurvey
  update: Update
  finalize: () => void
  backToFlaeche: () => void
}

const Summary: React.FC<Props> = ({ survey, update, finalize, backToFlaeche }) => {
  return (
    <FullHeightContentWrapper className="!py-0 !px-3">
      <div className="flex flex-col gap-5 h-full pt-8">
        <GoBack onClick={backToFlaeche} />
        <div className="flex flex-col md:flex-row gap-8 md:gap-10 h-full">
          <div className="flex-1 hidden md:block">
            <Config survey={survey} update={update} />
          </div>
          <div className="flex-1">
            <DeskSharingAndSummary survey={survey} update={update} />
          </div>
          <div className="flex-1">
            <Result survey={survey} update={update} finalize={finalize} />
          </div>
        </div>
      </div>
    </FullHeightContentWrapper>
  )
}

export default Summary
